module.exports = __webpack_public_path__ + "static/media/YF55_1.3cfa746d.jpg";